import { path } from 'ramda'
import useAvailableApps from './useAvailableApps'
import { useCMSEntries } from 'mage-cms'
import { useEducationProfileEvents, useEducationFeatures } from 'education-tools'

const isRequiredAppAvailable = (availableApps = []) => orientationItem => {
  if (orientationItem.requiredApps && orientationItem.requiredApps.length > 0) {
    for (const requiredApp of orientationItem.requiredApps) {
      if (!availableApps.includes(requiredApp)) {
        return false
      }
    }
  }
  return true
}

const isExperimentActive = features => orientationItem => {
  if (orientationItem.experimentationFeature) {
    const activeVariate = path([orientationItem.experimentationFeature, 'variate_id'], features)
    return activeVariate === orientationItem.experimentationVariate
  } else {
    return true
  }
}

const isPending = events => orientationItem => {
  return orientationItem.goalEvents.some(event => !events.includes(event))
}

/**
 * @returns list of OrientationItems from contentful,
 * where the apps defined as required are available for the current user
 */
function useOrientation(slug, tokenHelper) {
  const entries = useCMSEntries({
    contentType: 'Orientation',
    filters: { slug },
    include: 2 // include orientationItems.target
  })
  const availableApps = useAvailableApps(tokenHelper)
  const events = useEducationProfileEvents()
  const features = useEducationFeatures()

  if (!entries || !events || !features) {
    return { isLoading: true }
  }

  const entry = entries[0]

  if (!entry) {
    return { isLoading: false }
  }

  const filteredOrientationItems = entry.orientationItems
    .filter(isExperimentActive(features))
    .filter(isRequiredAppAvailable(availableApps))
    .filter(isPending(events))

  return {
    isLoading: false,
    data: {
      ...entry,
      orientationItems: filteredOrientationItems
    }
  }
}

export default useOrientation
